module.exports = __webpack_public_path__ + "static/img/4.d8f31bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/zh/4.png
// module id = /JFH
// module chunks = 0